module.exports = __webpack_public_path__ + "static/item--power-strip@3x.dc8718a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--power-strip@3x.png
// module id = 656
// module chunks = 126511778744290